export default "__VITE_ASSET__DJbNMW98__"